import { createFileRoute } from '@tanstack/react-router'
import { ActivateForm } from '@/features/auth/activate-form'

/** Public route opened from an access card; the activation code lives in the URL fragment. */
export const Route = createFileRoute('/activate')({ component: ActivateForm })
